export const RCV_SCHEDULE_ON_BEHALF_GUIDANCE_LINK =
  'https://support.ringcentral.com/app/video/desktop-web/setting-delegate-schedule-meeting-on-your-behalf-outlook.html';
